export default __webpack_public_path__ + "static/media/cynthia.84f9ee49.jpg";